/* eslint-disable @typescript-eslint/no-explicit-any */
import get from 'lodash/get';
import moment from 'moment';

import { ProgramItem, SLOT_DURATION_MINUTES } from '../../../group-visits/types';

/**
 * Créneau au format "YYYY-MM-DD HH:mm - HH:mm" (fin optionnelle, jour de fin optionnel).
 * Séparateurs acceptés : "-", "–", "—", "→", ">", "to".
 */
const SLOT_REGEX = /^(\d{4}-\d{2}-\d{2})[ T](\d{1,2}:\d{2})(?:\s*(?:-|–|—|→|>|to)\s*(?:(\d{4}-\d{2}-\d{2})[ T])?(\d{1,2}:\d{2}))?$/;

const SLOT_FORMAT = 'YYYY-MM-DD H:mm';

export type SlotDates = { startDate?: string; endDate?: string };

/** Parse un créneau "2026-11-17 09:30 - 12:00" en dates ISO début/fin */
export function parseSlot(slot?: string, durationInMinutes = SLOT_DURATION_MINUTES): SlotDates {
  if (!slot || typeof slot !== 'string') return {};
  const match = SLOT_REGEX.exec(slot.trim());
  if (!match) return {};
  const [, day, startTime, endDay, endTime] = match;
  const start = moment(`${day} ${startTime}`, SLOT_FORMAT);
  if (!start.isValid()) return {};
  const end = endTime
    ? moment(`${endDay || day} ${endTime}`, SLOT_FORMAT)
    : start.clone().add(durationInMinutes, 'minutes');
  return {
    startDate: start.format(),
    endDate: end.isValid() && end.isAfter(start) ? end.format() : undefined,
  };
}

type SlotOptions = { slotField?: string; slotDuration?: number };

/** Dates du créneau : startDate/endDate s'ils existent, sinon parsing du champ "slot" */
export function getSlotDates(
  group: Record<string, any>,
  { slotField = 'slot', slotDuration }: SlotOptions = {},
): SlotDates {
  if (group?.startDate) return { startDate: group.startDate, endDate: group.endDate };
  return parseSlot(get(group, slotField), slotDuration);
}

/** Normalise une liste d'éléments (ids bruts ou objets) en liste d'ids */
export function toIds(items?: ProgramItem[] | ProgramItem): string[] {
  if (!items) return [];
  return ([] as ProgramItem[])
    .concat(items)
    .map((item) => (typeof item === 'string' ? item : item?._id || item?.value))
    .filter((id): id is string => !!id);
}
